import { Link } from "react-router-dom";
import { Calendar, ArrowRight } from "lucide-react";
import { format } from "date-fns";

export const BlogCard = ({ post }) => {
  const { title, slug, excerpt, image_url, author, created_at } = post;

  const formattedDate = created_at ? format(new Date(created_at), "MMM dd, yyyy") : "";

  return (
    <Link
      to={`/blog/${slug}`}
      className="blog-card bg-[#121212] border border-[#2A2A2A] overflow-hidden group block"
      data-testid={`blog-card-${slug}`}
    >
      {/* Image */}
      <div className="aspect-video overflow-hidden">
        <img
          src={image_url}
          alt={title}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
      </div>

      {/* Content */}
      <div className="p-6">
        {/* Meta */}
        <div className="flex items-center gap-4 text-[#A1A1AA] text-xs mb-3">
          <span className="flex items-center gap-1">
            <Calendar size={12} />
            {formattedDate}
          </span>
          <span>By {author}</span>
        </div>

        {/* Title */}
        <h3 className="font-['Oswald'] text-xl font-semibold text-white mb-3 group-hover:text-[#C9A227] transition-colors">
          {title}
        </h3>

        {/* Excerpt */}
        <p className="text-[#A1A1AA] text-sm leading-relaxed mb-4 line-clamp-2">
          {excerpt}
        </p>

        {/* Read More */}
        <div className="flex items-center gap-2 text-[#C9A227] text-sm font-semibold uppercase tracking-wider">
          Read Article
          <ArrowRight size={16} className="group-hover:translate-x-2 transition-transform" />
        </div>
      </div>
    </Link>
  );
};
